module.exports = __webpack_public_path__ + "img/21.abd2e994.jpg";